import React from 'react';
import { TOOLTIP_POSITION, TooltipV2 as Tooltip } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const BulkEditDisabledCampaignsGroupsTooltip = () => (
    <Tooltip position={TOOLTIP_POSITION.RIGHT} arrow>
        <FormattedMessage
            id="bulk.action.campaignsGroup.checkbox.tooltip"
            defaultMessage="Campaigns Group cannot be edited due to status."
        />
    </Tooltip>
);
